import classNames from "classnames";

import { Typography } from "../Typography";
import styles from "./Heading4.module.scss";

export const Heading4 = ({
  as = "h4",
  className,
  color,
  children,
  plain = false,
}) => (
  <Typography
    className={classNames(className, styles.element)}
    color={color}
    as={as}
    plain={plain}
  >
    {children}
  </Typography>
);
